import { motion } from "framer-motion";
import { CalendarCheck, PhoneCall, Disc3 } from "lucide-react";
import { JR_PHOTOS } from "./juniorData";

const CHIPS = ["Ages 10–17", "1-on-1 coaching", "WWCC & police checked", "Club-standard Pioneer gear"];
const STEPS = [
  { icon: CalendarCheck, title: "Book online", text: "Pick a package and lock in your session dates in a couple of minutes." },
  { icon: PhoneCall, title: "We call & load their USB", text: "A quick chat with you, then we load their favourite songs onto their own USB." },
  { icon: Disc3, title: "Mix from day one", text: "Real beatmatching, mixing and transitions on club gear, from the very first lesson." },
];

const Photo = ({ src, alt, className, tilt, delay }) => (
  <div className={`${tilt} ${className}`}>
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay }}
      whileHover={{ scale: 1.03 }}
      className="h-full rounded-3xl overflow-hidden border-4 border-black shadow-[8px_8px_0_#000]"
    >
      <img src={src} alt={alt} loading="lazy" className="w-full h-full object-cover" />
    </motion.div>
  </div>
);

export const JuniorVibe = () => (
  <section className="relative py-20 md:py-28 bg-gradient-to-br from-lime-300 via-cyan-300 to-pink-400 overflow-hidden" data-testid="jr-vibe">
    <div className="relative max-w-7xl mx-auto px-6">
      <div className="max-w-3xl">
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-black tracking-tight leading-[0.95]">
          Where young DJs <span className="font-serif italic font-normal">find their sound.</span>
        </h2>
        <div className="flex flex-wrap gap-2 mt-6">
          {CHIPS.map((c) => <span key={c} className="px-4 py-2 rounded-full bg-black text-white text-sm font-semibold">{c}</span>)}
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-12 gap-4 md:gap-6 mt-12">
        <Photo src={JR_PHOTOS.friends} alt="Teen friends celebrating at the decks" tilt="-rotate-2" className="md:col-span-4 aspect-square md:aspect-auto md:h-[380px]" delay={0} />
        <Photo src={JR_PHOTOS.group} alt="Group of teens learning to DJ" tilt="rotate-1" className="col-span-2 md:col-span-5 aspect-[4/3] md:aspect-auto md:h-[380px] order-first md:order-none" delay={0.1} />
        <Photo src={JR_PHOTOS.decks} alt="Pioneer CDJ-3000s in the Dream Makers DJ Room" tilt="rotate-2" className="md:col-span-3 aspect-square md:aspect-auto md:h-[380px]" delay={0.2} />
      </div>
      <div className="grid md:grid-cols-3 gap-5 mt-14" data-testid="jr-how-it-works">
        {STEPS.map(({ icon: Icon, title, text }, i) => (
          <div key={title} className="rounded-3xl p-6 bg-black text-white">
            <div className="flex items-center gap-3 mb-3">
              <span className="w-10 h-10 rounded-full bg-lime-300 text-black font-display font-bold flex items-center justify-center">{i + 1}</span>
              <Icon className="w-5 h-5 text-pink-400" />
            </div>
            <p className="font-display text-xl font-bold">{title}</p>
            <p className="text-white/65 text-sm mt-1">{text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
